// Lib
import React from 'react';

// Components
import Button from '../index';
import Feather from '../../Feather';

import { useStyles } from './EditRequestButtonStyles';

const EditRequestButton = ({ onClick = () => {}, title, className }) => {
  const { classes, cx } = useStyles();

  return (
    <Button
      onClick={onClick}
      className={cx(classes.button, className)}
      variant="text">
      <Feather type="edit" className={classes.icon} />
      {title}
    </Button>
  );
};

export default EditRequestButton;
